import { getModuleUrl, i18n } from "@dehub/theme";
import { store, persistor } from "../store";
import { message } from "./Message";
import { authChange } from "../store/Auth";
import { HttpHandler } from "./HttpHandler";
import { HttpRequest as BaseHttpRequest } from "./HttpRequest";
let sessionExpiredHandled = false;

export class HttpRequest extends BaseHttpRequest {
  store = store;
  errorHandler = (statusCode: number, error: HttpHandler): HttpHandler => {
    if (statusCode === 401 && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      store.dispatch(authChange());
      message.error(i18n.t("common:session.expired", { defaultValue: "Таны нэвтэрсэн хугацаа дууссан байна. Дахин нэвтэрнэ үү." }));

      const h = window.location.hostname.split(".");
      const loginUrl = `${h.length >= 3 && h[0] === "b2b" ? window.location.origin : getModuleUrl("")}/login?logout=1`;

      persistor.purge().finally(() => {
        setTimeout(() => {
          window.location.href = loginUrl;
        }, 1500);
      });
    }

    throw error;
  };
}

function currencyFormat(num: number, opts?: { withSymbol?: boolean }) {
  const formatted =
    parseFloat(`${num}`)
      ?.toFixed(2)
      ?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") ?? "0.00";
  // Table cells stack cleaner without ₮ (Харилцагчийн тооцоо reference).
  // Cards / copy / tooltips keep the symbol by default.
  if (opts?.withSymbol === false) return formatted;
  return `${formatted} ₮`;
}

export { currencyFormat };
